import { useClassNames } from '@common';
import React, { useState } from 'react';
import './Tabs.scss';

type themes = 'primary' | 'default';
type kinds = 'horizontal' | 'vertical';

interface TabsPropsBase {
	theme?: themes;
	kind?: kinds;
	className?: string;
	defaultIndex?: number;
}

type TabsProps = React.PropsWithChildren<TabsPropsBase>;

function Tabs(props: TabsProps): JSX.Element {
	const {
		children,
		className,
		theme = 'default',
		kind = 'vertical',
		defaultIndex = 0,
	} = props;

	const [activeTabIndex, setActiveTabIndex] = useState<number>(defaultIndex);

	const tabs = children as JSX.Element[];

	const activeTab = tabs[activeTabIndex];
	

	const tabTitles = tabs.map((t, index) => {
		let classes = 'tab__title';
		if (index == activeTabIndex){
			classes += ' tab__title-active';
		}
		return !t.props.hidden && <div key={index} className={classes} onClick={() => setActiveTabIndex(index)}>{t.props.title}</div>
	});

	const classes = useClassNames(
		'tabs',
		kind,
		theme,
		className,
	);

	const trailingView = activeTab.props.trailing && (
		<div className="tabs__trailing">
			{activeTab.props.trailing}
		</div>
	);

	return (
		<div className={classes}>
			<div className="tabs__titles">
				{tabTitles}
				{trailingView}
			</div>
			{activeTab}
		</div>
	);
}

const MemoisedTabs = React.memo(Tabs);

export {MemoisedTabs as Tabs};
export type {TabsProps};